{
  "questions": {
    "culture": {
      "detailsPlaceholder": "<p>कृपया अंग्रेज़ी में भरें। उदाहरण के लिए:</p>\n<p>Whānau to be present, need interpreter, specific dietary customs</p>",
      "label": "क्या आपकी कोई सांस्कृतिक या पारिवारिक आवश्यकताएँ हैं?",
      "nextLabel": "$t(common:next): <b>अन्य विशेष आवश्यकताएं या जानकारी</b>",
      "title": "<h3>सांस्कृतिक या पारिवारिक ज़रूरतें</h3>"
    },
    "language": {
      "de": "Deutsch / German",
      "detailsLabel": "आपकी पसंदीदा भाषा क्या है?",
      "fj": "Vosa Vakaviti / Fijian",
      "fr": "Français / French",
      "ja": "日本語 / Japanese",
      "ko": "한국어 / Korean",
      "label": "क्या आपको अंग्रेज़ी समझने में कठिनाई होती है?",
      "mi": "Te Reo Māori",
      "ms": "Malay / Malaysian",
      "nextLabel": "$t(common:next): <b>धार्मिक या आध्यात्मिक आवश्यकताएँ</b>",
      "other": "अन्य",
      "pt": "Português / Portuguese",
      "sm": "Gagana Samoa / Samoan",
      "ta": "தமிழ் / Tamil",
      "title": "<h3>अंग्रेज़ी समझना</h3>",
      "tl": "Tagalog / Tagalog",
      "to": "Lea Faka-Tonga / Tongan",
      "zh": "简体中文 / Chinese"
    },
    "mobility": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए:<br/>वॉकर या व्हीलचेयर का उपयोग करते हैं; बिस्तर पर चढ़ने में सहायता की आवश्यकता",
      "label": "क्या आपको कोई विकलांगता है या चलने-फिरने में सहायता की आवश्यकता है?",
      "nextLabel": "$t(common:next): <b>अंग्रेज़ी समझना</b>",
      "title": "<h3>गतिशीलता</h3>"
    },
    "other": {
      "detailsPlaceholder": "केवल वही साझा करें जो आपको प्रासंगिक लगे। इससे हमें आपकी बेहतर सहायता करने में मदद मिलती है।",
      "label": "क्या आपकी कोई अन्य विशेष ज़रूरतें हैं, या कुछ और है जो आप हमें बताना चाहेंगे?",
      "nextLabel": "$t(common:next): <b>आपकी बाउल प्रेप प्राप्त करना</b>",
      "title": "<h3>अन्य विशेष आवश्यकताएँ या जानकारी</h3>"
    },
    "prep": {
      "label": "कृपया चुनें कि आप इसे कैसे प्राप्त करना चाहेंगे:",
      "nextLabel": "$t(common:next): <b>बुकिंग पूरा करें</b>",
      "pick-up-from-hospital": "<label>{{company}} से पिक-अप करें</label>\n<p>खुलने के समय के दौरान रिसेप्शन से अपनी प्रेप पैक लें।</p>",
      "pick-up-from-local-pharmacy": "<label>अपने नज़दीकी फ़ार्मेसी से पिक-अप करें</label>\n<p>हम आपको एक प्रिस्क्रिप्शन ईमेल करेंगे जिसे आप अपनी फ़ार्मेसी में ले जा सकते हैं।</p>",
      "receive-by-mail": "<label>डाक द्वारा प्राप्त करें</label>\n<p>हम आपका प्रेप पैक आपके द्वारा दिए गए घर के पते पर कुरियर करेंगे।</p>",
      "text": "आपकी प्रक्रिया की तैयारी के लिए, आपको एक विशेष दवा लेनी होगी जो आपकी आंतों को साफ करती है।",
      "title": "<h3>अपनी आंत की दवा प्राप्त करना</h3><p>आपकी प्रक्रिया की तैयारी के लिए, आपको एक विशेष दवा लेनी होगी जो आपकी आंतों को साफ करती है।</p>"
    },
    "religion": {
      "detailsPlaceholder": "<p>कृपया अंग्रेज़ी (English) में भरें। उदाहरण के लिए:<br/>Quiet space for prayer, prefer same-gender staff for personal care</p>",
      "label": "क्या आपकी कोई धार्मिक या आध्यात्मिक आवश्यकताएं हैं?",
      "nextLabel": "$t(common:next): <b>सांस्कृतिक या पारिवारिक आवश्यकताएं</b>",
      "title": "<h3>धार्मिक या आध्यात्मिक आवश्यकताएं</h3>"
    }
  }
}
